import React from 'react';
import { Link } from 'react-router-dom';

const Department = (props) => {
    const { title, description, img ,id } = props.department;
    return (
        <div>
            <section className="text-gray-600 body-font">
                <div className="container mx-auto flex px-2 py-8 items-center justify-center flex-col">
                    <img className="lg:w-4/6 md:w-3/6 w-5/6 mb-10 object-cover object-center rounded" alt="hero" src={img} />
                    <div className="text-center lg:w-2/3 w-full">
                        <h1 className="title-font sm:text-2xl text-3xl mb-4 font-medium text-gray-900">{title}</h1>
                        <p className="mb-8 leading-relaxed">{description}</p>
                        <div className="flex justify-center">
                        
                        <Link to={`/details/${id}`}>
                        <button className="inline-flex text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded text-lg">Details</button>
                        </Link>
                          <Link to="/contact">
                          <button className="ml-4 inline-flex text-gray-700 bg-gray-100 border-0 py-2 px-6 focus:outline-none hover:bg-gray-200 rounded text-lg">Contact</button>
                          </Link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Department;